<template>
    <v-select
        ref="suppliers"
        :items="suppliers"
        :item-text="(item) => item.name"
        :item-value="(item) => item"
        :value="value"
        @input="$emit('input', $event)"
        label="供應商"
        placeholder="請選擇..."
    ></v-select>
</template>

<script>
import { suppliers } from '@/api'

export default {
    props: {
        value: {
            type: Object,
            default:() => {}
        }
    },
    data() {
        return {
            suppliers: []
        }
    },
    mounted() {
        suppliers.get().then(response => this.suppliers = response.data)
    },
}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/SupplierSelect.vue